var map = {
	"./__buildingType_BT.png": 9876,
	"./__buildingType_LC.png": 7799,
	"./buildingType_LC.png": 6608,
	"./buildingType_MI.png": 650,
	"./floorComposition_concret.png": 6983,
	"./floorComposition_solidBrick.png": 7902,
	"./floorComposition_unknow.png": 2135,
	"./floorComposition_wood.png": 3988,
	"./floorType_basement.png": 3904,
	"./floorType_crawlspace.png": 1928,
	"./floorType_ground.png": 9921,
	"./no-image.png": 373,
	"./roofColor_dark.png": 2387,
	"./roofColor_light.png": 5004,
	"./roofColor_medium.png": 5943,
	"./roofColor_unknow.png": 1790,
	"./roofComposition_concret.png": 9287,
	"./roofComposition_parget.png": 9331,
	"./roofComposition_solidBrick.png": 8146,
	"./roofComposition_unknow - Copie.png": 6375,
	"./roofComposition_unknow---Copie.png": 4193,
	"./roofComposition_unknow.png": 7351,
	"./roofComposition_wood.png": 8265,
	"./roofType_converted.png": 1215,
	"./roofType_flat.png": 2444,
	"./roofType_lost.png": 9038,
	"./roomShape_1.png": 1509,
	"./roomShape_2.png": 5538,
	"./roomShape_3.png": 1299,
	"./roomShape_4.png": 465,
	"./roomShape_5.png": 9371,
	"./roomShape_6.png": 866,
	"./wallsColor_dark.png": 954,
	"./wallsColor_light.png": 489,
	"./wallsColor_medium.png": 9143,
	"./wallsComposition_aeratedConcrete.png": 8723,
	"./wallsComposition_brickWall.png": 3649,
	"./wallsComposition_cinderBlock.png": 421,
	"./wallsComposition_concret.png": 324,
	"./wallsComposition_monomurBrick.png": 4015,
	"./wallsComposition_solidBrick--.png": 1171,
	"./wallsComposition_solidBrick.png": 8328,
	"./wallsComposition_stone.png": 6822,
	"./wallsComposition_unknow.png": 1392,
	"./wallsComposition_wood.png": 9994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9879;